import React from 'react';
import PropTypes from 'prop-types';
import {I18n} from '@aws-amplify/core';

import {PacFormikDropdown, PacFormikToggleSwitch,} from 'pac-platform-ui-components';

import {Field} from 'formik';


import {SimpleGrid, Title} from '@mantine/core';

const languages = [
    {id: 'en', label: 'English'},
    {id: 'ja', label: 'Japanese'},
    {id: 'bg', label: 'Bulgarian'},
    {id: 'hi', label: 'Hindi'},
];

const languagesOptions = languages.map((language) => {
    return {value: language.id, label: language.label};
});

const maxApplicationsOptions = [...Array(2).keys()].map((number) => {
    return {value: number + 1, label: number + 1};
});

const FormComponent = ({values}) => {
    return (
        <SimpleGrid>
            <SimpleGrid>
                <Title order={4} htmlFor="language">
                    {I18n.get('Language')}
                </Title>
                <Field
                    autoFocus
                    type="text"
                    name="language"
                    options={languagesOptions}
                    component={PacFormikDropdown}
                />
            </SimpleGrid>

            <SimpleGrid>
                <Title order={4} htmlFor="show_return_to">
                    Show list of return to applications
                </Title>
                <Field
                    name="show_return_to"
                    options={{
                        labelWhenTrue: 'Show',
                        labelWhenFalse: 'Hide',
                    }}
                    component={PacFormikToggleSwitch}
                />
            </SimpleGrid>

            {values['show_return_to'] === true ? (
                <SimpleGrid>
                    <Title order={4} htmlFor="max_return_to">
                        Number of applications to show
                    </Title>

                    <Field
                        type="text"
                        name="max_return_to"
                        options={maxApplicationsOptions}
                        component={PacFormikDropdown}
                    />
                </SimpleGrid>
            ) : (
                <div/>
            )}

            <SimpleGrid>
                <Title order={4} htmlFor="password_and_sso">
                    Allow Selection of Sign In Method (not common)
                </Title>
                <Field
                    name="password_and_sso"
                    options={{
                        labelWhenTrue: 'Enabled',
                        labelWhenFalse: 'Disabled',
                    }}
                    component={PacFormikToggleSwitch}
                />
            </SimpleGrid>
        </SimpleGrid>
    );
};

FormComponent.propTypes = {
    values: PropTypes.object.isRequired,
    setFieldValue: PropTypes.func,
};

export default FormComponent;
